import { render } from "./FilterCollection.vue?vue&type=template&id=69dae900"
import script from "./FilterCollection.vue?vue&type=script&lang=js"
export * from "./FilterCollection.vue?vue&type=script&lang=js"

import "./FilterCollection.vue?vue&type=style&index=0&id=69dae900&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__